module.exports = __webpack_public_path__ + "img/Cynthia.42800233.jpeg";